import { Form, HousingAlert, Sender } from "@garantidos/components"

import Text from "@mobi/ds/components/Text"

import AmortizationCard from "./components/AmortizationCard/index"
import AttentionCard from "./components/AttentionCard"
import SummaryAccordion from "./components/SummaryAccordion/index"
import SummaryProposal from "./components/SummaryProposal"

import useSummary from "./hooks"

import "./style.scss"

const Summary = () => {
  const {
    handlePrevStep,
    onSubmitCallback,
    form,
    isShareIncome,
    errorMessage,
    setErrorMessage,
    isSameAddress,
    isSameContact,
    labelAmortization,
    handleOpenInfo,
    infoMessage,
    setInfoMessage,
    isLoading
  } = useSummary()

  return (
    <div className="summary">
      <div className="summary__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <HousingAlert message={infoMessage} setMessage={setInfoMessage} />

        <Text as="h1" className="summary__title">
          informações da sua proposta
        </Text>

        <Text as="p" className="summary__info">
          Confirme seus dados e envie sua proposta para análise de crédito:
        </Text>

        <div className="summary__accordionsWrapper">
          <AmortizationCard
            labelAmortization={labelAmortization}
            handleOpenInfo={handleOpenInfo}
          />
          <SummaryProposal handleOpenInfo={handleOpenInfo} />

          <SummaryAccordion
            isShareIncome={isShareIncome}
            isSameAddress={isSameAddress}
            isSameContact={isSameContact}
          />
        </div>

        <AttentionCard />
        <Form onSubmit={onSubmitCallback} form={form}>
          <Sender
            onPrev={handlePrevStep}
            nextLabel="enviar para análise"
            data_testid="submit"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default Summary
